import { ReactNode } from 'react'
import { Link } from '@inertiajs/react'
import { TessanLogo } from '@/components/ui/TessanLogo'

interface AuthLayoutProps {
  children: ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-bg-page flex flex-col">
      {/* Header */}
      <header className="py-6">
        <div className="max-w-7xl mx-auto px-4">
          <Link href="/" className="text-tessan-green hover:text-tessan-green-dark transition-colors">
            <TessanLogo height={28} />
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-sm text-text-muted">
        © {new Date().getFullYear()} Tessan. Tous droits réservés.
      </footer>
    </div>
  )
}
